import portrait from '../assets/andreas-heinrichs-portrait.webp';
import heroLandscape from '../assets/landscape-hero.webp';
import ackerImage from '../assets/landscape-acker.webp';
import waldImage from '../assets/landscape-wald.webp';
import gruenlandImage from '../assets/landscape-gruenland.webp';
import aerialImage from '../assets/landscape-aerial.webp';
import bauernhofImage from '../assets/landscape-bauernhof.webp';
import weinbergImage from '../assets/landscape-weinberg.webp';
import eigenjagdImage from '../assets/landscape-eigenjagd.webp';
import sonderkulturenImage from '../assets/landscape-sonderkulturen.webp';
import oekopunkteImage from '../assets/landscape-oekopunkte.webp';
import biogasImage from '../assets/landscape-biogas.webp';
import solarWindImage from '../assets/landscape-solar-wind.webp';
import rinderstallImage from '../assets/landscape-rinderstall.webp';
import hofGesamtImage from '../assets/landscape-hof-gesamtpaket.webp';
import schweinestallImage from '../assets/landscape-schweinestall.webp';
import reitanlageImage from '../assets/landscape-reitanlage.webp';
import hofstelleImage from '../assets/landscape-hofstelle.webp';

export const ANDREAS_PORTRAIT = portrait;
export const HERO_LANDSCAPE = heroLandscape;
export const AERIAL_LANDSCAPE = aerialImage;
export const LAND_IMAGES = { ackerland: ackerImage, wald: waldImage, gruenland: gruenlandImage, bauernhof: bauernhofImage, weinberg: weinbergImage, eigenjagd: eigenjagdImage, sonderkulturen: sonderkulturenImage, oekopunkte: oekopunkteImage, biogas: biogasImage, solarwind: solarWindImage, rinderstall: rinderstallImage, hofgesamt: hofGesamtImage, schweinestall: schweinestallImage, reitanlage: reitanlageImage, hofstelle: hofstelleImage };
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ackermarkt-1/artifacts/gqrpaa7w_2f739523-41ea-4007-83dd-16892d3ecf1f.png';
export const LOGO_LIGHT_URL = 'https://customer-assets.emergentagent.com/job_ackermarkt-1/artifacts/8yo51eot_016e01cf-cf41-4e29-ba00-41d2486d2e45.png';
